
import { AccountMgtListFilterActions, AccountMgtListFilterActionTypes } from '../actions/account-mgt-list-filter.actions';

export interface State {
  RegionIdOption: number;
  AuthorityIdOption: number;
}

export const initialState: State = {
  RegionIdOption: 1,
  AuthorityIdOption: -1
};

export function reducer(state = initialState, action: AccountMgtListFilterActions): State {
  switch (action.type) {

    case AccountMgtListFilterActionTypes.LoadAccountMgtListFilters:
      return state;

    case AccountMgtListFilterActionTypes.SelectAccountMgtListFilters:
      return {...state, RegionIdOption: action.payload.RegionId, AuthorityIdOption: action.payload.Authority};

    default:
      return state;
  }
}
